var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"esFixed",staticClass:"appDialog esFixed"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"esBody"},[_c('img',{attrs:{"src":"https://oss.eventnet.cn/H5/CHENGHAO/Lenovo2022/img/msg/5.png"}})])
}]

export { render, staticRenderFns }